export default "__VITE_ASSET__DH_b_rJ4__"